import { render } from "./GanttGridHeader.vue?vue&type=template&id=80e622b6"
import script from "./GanttGridHeader.vue?vue&type=script&lang=ts"
export * from "./GanttGridHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script